import React from 'react'
import { CurrencyFormat, DateFormat } from '../../../helpers/formatting'
import Loading from '../../../components/Loading'

/**
 * Presentational payment-schedule table + "System Auto-Adjustments" notice, extracted from
 * VerificationPaymentSchedule. Display only — no API calls, no form state.
 */
export default function PaymentScheduleTable({
  paymentScheduleData,
  autoAdjustedFields,
  generatingSchedule,
  paymentMethod,
}) {
  return (
    <div>
      {autoAdjustedFields.length > 0 && (
        <div className="notification is-warning is-light mb-3" data-testid="payment-schedule-auto-adjustments">
          <p className="has-text-weight-bold mb-1">System Auto-Adjustments</p>
          <p className="mb-1">
            The following fields were automatically changed by the system.
            Please review before continuing.
          </p>
          <ul style={{ listStyleType: 'disc', paddingLeft: '1.25rem' }}>
            {autoAdjustedFields.map((adj) => (
              <li key={adj.field} data-testid="auto-adjustment-row">
                <strong data-testid="auto-adjustment-field">{adj.field}</strong>: changed from{' '}
                <strong>{adj.from}</strong> to <strong>{adj.to}</strong>
              </li>
            ))}
          </ul>
        </div>
      )}
      {paymentScheduleData?.payment_schedule && (
        <div className="table-container mb-0 position-relative">
          {generatingSchedule && (
            <div className="loader-wrapper">
              <Loading />
            </div>
          )}
          <table className="lox-hooktable-table table is-bordered is-striped is-narrow is-hoverable is-fullwidth is-grey mb-3" data-testid="payment-schedule-table">
            <thead>
              <tr>
                <th
                  colSpan="6"
                  className="is-selected has-text-left lox-payment-schedule-color"
                >
                  Payment Schedule
                </th>
              </tr>
            </thead>
            <thead>
              <tr>
                <th className="is-selected has-text-centered lox-payment-schedule-color">
                  #
                </th>
                <th className="is-selected has-text-centered lox-payment-schedule-color">
                  Date
                </th>
                <th className="is-selected has-text-centered lox-payment-schedule-color">
                  Pay Method
                </th>
                <th className="is-selected has-text-centered lox-payment-schedule-color">
                  Principal $
                </th>
                <th className="is-selected has-text-centered lox-payment-schedule-color">
                  Interest $
                </th>
                <th className="is-selected has-text-centered lox-payment-schedule-color">
                  Total $$$
                </th>
              </tr>
            </thead>
            <thead>
              <tr>
                <th
                  colSpan="3"
                  className="is-selected has-text-centered"
                  style={{ backgroundColor: '#7F7F7F' }}
                >
                  TOTAL PLAN
                </th>
                <th
                  className="is-selected has-text-centered"
                  style={{ backgroundColor: '#7F7F7F' }}
                >
                  <CurrencyFormat
                    value={paymentScheduleData?.payment_schedule?.schedule?.reduce(
                      (total, item) => total + item.principal_amount,
                      0
                    )}
                  />
                </th>
                <th
                  className="is-selected has-text-centered"
                  style={{ backgroundColor: '#7F7F7F' }}
                >
                  <CurrencyFormat
                    value={paymentScheduleData?.payment_schedule.total_interest}
                  />
                </th>
                <th
                  className="is-selected has-text-centered"
                  style={{ backgroundColor: '#7F7F7F' }}
                >
                  <CurrencyFormat
                    value={paymentScheduleData?.payment_schedule.total_amount}
                  />
                </th>
              </tr>
            </thead>
            <tbody>
              {paymentScheduleData?.payment_schedule.schedule?.map(
                (item, index) => (
                  <tr key={item.date} data-testid="schedule-row">
                    <td
                      className="has-text-centered"
                      style={{ whiteSpace: 'nowrap' }}
                    >
                      {index + 1}
                    </td>
                    <td
                      className="has-text-centered"
                      style={{ whiteSpace: 'nowrap' }}
                    >
                      <DateFormat dateString={item.date} />
                    </td>
                    <td
                      className="has-text-centered"
                      style={{ whiteSpace: 'nowrap' }}
                      data-testid="schedule-row-method"
                    >
                      {paymentMethod}
                    </td>
                    <td
                      className="has-text-centered"
                      style={{ whiteSpace: 'nowrap' }}
                    >
                      <CurrencyFormat value={+item.principal_amount} />
                    </td>
                    <td
                      className="has-text-centered"
                      style={{ whiteSpace: 'nowrap' }}
                    >
                      <CurrencyFormat
                        value={+item.payment - +item.principal_amount}
                      />
                    </td>
                    <td
                      className="has-text-centered"
                      style={{ whiteSpace: 'nowrap' }}
                      data-testid="schedule-row-total"
                    >
                      <CurrencyFormat value={+item.payment} />
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
